import { render, staticRenderFns } from "./GlossQueryField.vue?vue&type=template&id=2a832768&scoped=true"
import script from "./GlossQueryField.vue?vue&type=script&lang=ts"
export * from "./GlossQueryField.vue?vue&type=script&lang=ts"
import style0 from "./GlossQueryField.vue?vue&type=style&index=0&id=2a832768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a832768",
  null
  
)

export default component.exports